import React from "react";
import './Legend.scss'
import { usePickerContext } from "../../picker/hooks/usePickerContext"

export function Legend({ categories, categoriesPrices = [] }) {
    const { state } = usePickerContext();
    var nbPits = categoriesPrices.filter(categoryPrice => categoryPrice.categoryType === 'PIT').length
    var nbSeats = categoriesPrices.filter(categoryPrice => categoryPrice.categoryType === 'SEAT').length
    const legends = categories.map(category => {
        const categoryPrice = categoriesPrices.filter(categoryPrice => categoryPrice.categoryId === category.id)[0]
        return {
            category,
            categoryPrice
        }
    });

    var legend = <></>
    if(nbSeats > 0){
        var legendSeats =
        <>
            <li>
                <span className={'Legend-Seat Legend-Seat-Available'}/>
                <span>Place libre</span>
            </li>
            <li>
                <span className={'Legend-Seat Legend-Seat-Booked'}/>
                <span>Place réservée</span>
            </li>
            <li>
                <span className={'Legend-Seat Legend-Seat-Disabled'}/>
                <span>Place indisponible</span>
            </li>
        </>
        legend = legendSeats
    }
    if(nbPits > 0){
        var legendPits = 
        <>
            <li>
                <span className={'Legend-Pit Legend-Pit-Available'}/>
                <span>Zone disponible</span>
            </li>
            <li>
                <span className={'Legend-Pit Legend-Pit-Booked'}/>
                <span>Zone indisponible</span>
            </li>
        </>
        legend = legendPits

    }

    if(nbPits > 0 && nbSeats > 0){
        legend = <>{legendSeats}{legendPits}</>
    }

    return (
        <>
            <section className={"PickerContainer-section Legend-container"}>
                <header className="PickerContainer-sectionHeader">
                    <span className={"PickerContainer-title"}>Catégories :</span>
                </header>
                <ul className={"Legend-list"}>
                    {legends.map((legend, index) =>
                        <li className={"Legend-item"} key={index}>
                            <span className={"Legend-color"} style={{ backgroundColor: legend.category.color }}/>
                            <div className={"Legend-description"}>
                                <span className={"Legend-name"}>{legend.category.name}</span>
                                {!!legend.categoryPrice &&
                                <span className={"Legend-labels"}>{legend.categoryPrice.labels.join(' - ')}</span>
                                }
                            </div>
                        </li>
                    )}
                </ul>
            </section>
            <section className={"PickerContainer-section Legend-container"}>
                <header className="PickerContainer-sectionHeader">
                    <span className={"PickerContainer-title"}>Légende :</span>
                </header>
                <ul className={"Legend-list Legend-list-UI"}>
                    {legend}
                </ul>
            </section>
        </>
    )
}